/** 审核资产引用 URL 的前缀，节点提交审核后 url 会被替换为 `Asset://<id>`。 */
export const ASSET_REF_PREFIX = 'Asset://';

/** 判断 URL 是否为审核资产引用（`Asset://<id>`）。 */
export const isAssetRefUrl = (url: unknown): url is string =>
  typeof url === 'string' && url.startsWith(ASSET_REF_PREFIX);

/**
 * Asset:// 引用不可直接作为媒体源（播放/展示/下载），替换为提交审核时
 * 缓存在节点 data 上的预览 URL；非引用则原样返回。
 * 引用存在但预览缺失时返回 undefined（引用字符串本身不可用）。
 */
export const resolveAssetRefPreview = (
  url: string | undefined,
  previewUrl: string | undefined,
): string | undefined => {
  if (typeof url !== 'string' || !url) return undefined;
  return isAssetRefUrl(url) ? previewUrl || undefined : url;
};
